export default "__VITE_ASSET__CSSN68xz__"